"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initClientsideStoreRegistry = exports.InitialStateScripts = exports.deleteAllStores = exports.getAllStores = exports.getInitialStateName = void 0;
const react_1 = __importDefault(require("react"));
const react_sweet_state_1 = require("react-sweet-state");
const snakeCase_1 = __importDefault(require("lodash/snakeCase"));
const isomorphic_1 = require("../../isomorphic");
const window_1 = require("../../utils/window");
const components_1 = require("../components");
const registry_1 = require("../registry");
const config_1 = require("./config");
const modal_1 = require("./modal");
const product_1 = require("./product");
const select_1 = require("./select");
const shopping_portal_1 = require("./shopping-portal");
const weblabs_1 = require("./weblabs");
if ((0, window_1.isClientSide)()) {
    react_sweet_state_1.defaults.devtools = true;
}
const getInitialStateName = (storeName) => `__${(0, snakeCase_1.default)(storeName).toUpperCase()}__`;
exports.getInitialStateName = getInitialStateName;
const getAllStores = (scope) => {
    isomorphic_1.LOGGER.info('Getting ALL stores', scope);
    return {
        configState: registry_1.registry.getStore(config_1.configStore, scope).getState(),
        modalState: registry_1.registry.getStore(modal_1.modalStore, scope).getState(),
        productState: registry_1.registry.getStore(product_1.productStore, scope).getState(),
        selectRegistryState: registry_1.registry.getStore(select_1.selectRegistryStore, scope).getState(),
        shoppingPortalState: registry_1.registry.getStore(shopping_portal_1.shoppingPortalStore, scope).getState(),
        weblabState: registry_1.registry.getStore(weblabs_1.weblabStore, scope).getState()
    };
};
exports.getAllStores = getAllStores;
const deleteAllStores = (scope) => {
    isomorphic_1.LOGGER.info('Deleting ALL stores');
    registry_1.registry.deleteStore(config_1.configStore, scope);
    registry_1.registry.deleteStore(modal_1.modalStore, scope);
    registry_1.registry.deleteStore(product_1.productStore, scope);
    registry_1.registry.deleteStore(select_1.selectRegistryStore, scope);
    registry_1.registry.deleteStore(shopping_portal_1.shoppingPortalStore, scope);
    registry_1.registry.deleteStore(weblabs_1.weblabStore, scope);
};
exports.deleteAllStores = deleteAllStores;
const InitialStateScripts = (props) => {
    const { configState, modalState, productState, selectRegistryState, shoppingPortalState, weblabState } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(components_1.InitialStateScript, { name: (0, exports.getInitialStateName)(config_1.CONFIG_STORE_NAME), initialState: configState }),
        react_1.default.createElement(components_1.InitialStateScript, { name: (0, exports.getInitialStateName)(modal_1.MODAL_STORE_NAME), initialState: modalState }),
        react_1.default.createElement(components_1.InitialStateScript, { name: (0, exports.getInitialStateName)(product_1.PRODUCT_STORE_NAME), initialState: productState }),
        react_1.default.createElement(components_1.InitialStateScript, { name: (0, exports.getInitialStateName)(select_1.SELECT_STORE_NAME), initialState: selectRegistryState }),
        react_1.default.createElement(components_1.InitialStateScript, { name: (0, exports.getInitialStateName)(shopping_portal_1.SHOPPING_PORTAL_STORE_NAME), initialState: shoppingPortalState }),
        react_1.default.createElement(components_1.InitialStateScript, { name: (0, exports.getInitialStateName)(weblabs_1.WEBLAB_STORE_NAME), initialState: weblabState })));
};
exports.InitialStateScripts = InitialStateScripts;
const initClientsideStoreRegistry = (requestId) => __awaiter(void 0, void 0, void 0, function* () {
    if (registry_1.registry.stores.size === 0) {
        isomorphic_1.LOGGER.info('Initializing client store state registry...');
        const initialConfigState = (0, components_1.getInitialState)((0, exports.getInitialStateName)(config_1.CONFIG_STORE_NAME));
        const initialShoppingPortalState = (0, components_1.getInitialState)((0, exports.getInitialStateName)(shopping_portal_1.SHOPPING_PORTAL_STORE_NAME));
        const initialWebLabState = (0, components_1.getInitialState)((0, exports.getInitialStateName)(weblabs_1.WEBLAB_STORE_NAME));
        yield registry_1.registry.getStore(config_1.configStore, requestId).getActions().init(initialConfigState);
        yield registry_1.registry
            .getStore(shopping_portal_1.shoppingPortalStore, requestId)
            .getActions()
            .init(initialShoppingPortalState);
        yield registry_1.registry.getStore(weblabs_1.weblabStore, requestId).getActions().init(initialWebLabState);
        isomorphic_1.LOGGER.info('Initializing client store state registry complete');
    }
});
exports.initClientsideStoreRegistry = initClientsideStoreRegistry;
__exportStar(require("./config"), exports);
__exportStar(require("./modal"), exports);
__exportStar(require("./product"), exports);
__exportStar(require("./select"), exports);
__exportStar(require("./shopping-portal"), exports);
__exportStar(require("./weblabs"), exports);
